import db from '@/store/db';
import moment from 'moment';
import log from '@/logger';

export default {
  getDefaultKeyword: () => {
    return {
      type: 'Keyword',
      archived: false,
      createdAt: moment().format(),
      keyword: [],
    };
  },
  createKeyword: function (newProperties) {
    // console.log(newProperties.newProperties);
    var newKeyword = Object.assign({}, this.getDefaultKeyword(), newProperties.newProperties || {});
    // console.log(newKeyword);
    return db.organisationDb.post(newKeyword).then(function (doc) {
      newKeyword._id = doc.id;
      newKeyword._rev = doc.rev;
      return newKeyword;
    });
  },
  saveKeyword: function (keyword) {
    // console.log(JSON.stringify(diary));
    // var diary = {};
    if (keyword._id) {
      return db.organisationDb.put(keyword).then((response) => {
        return keyword;
      });
    } else {
      return db.organisationDb.post(keyword).then((response) => {
        keyword._id = response.id;
        return keyword;
      });
    }
  },
  getKeyword: function (id) {
    return db.organisationDb.get(id).then((Keyword) => {
      var d = Object.assign(this.getDefaultKeyword(), Keyword);
      return d;
    });
  },
  loadKeyword: function () {
    /* var options = {
      include_docs: true
    }; */
    return db.organisationDb
      .query('keyword')
      .then((result) => {
        /* var populated = [];
        console.log(JSON.stringify(result));
        for (var row of result.rows) {
          var project = row.value;
          project._id = row.id;
          populated.push(project);
        }
        result.rows[0].id */
        return result.rows;
      })
      .catch(function (err) {
        log.error('Unable to load keyword', err);
        return [];
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/keyword/keywordApi.js